// used by ChiefApplicationRow.jsx
import { gql } from '@apollo/client';

export const CERTIFICATE_COMMON_FIELDS = gql`
   fragment CertificateCommonFields on Certificate {
      id
      certificateNumber
      applicationId
      applicationType
      certificateStatus
      dateCreated
      dateIssued
      expiryDate
      dateApproved
      orderOfPayment {
         officialReceipt {
            orNumber
            dateIssued
            amount
         }
      }
   }
`;

export const COV_CERTIFICATE_FIELDS = gql`
   fragment COVCertificateFields on Certificate {
      covCertificateData {
         applicationNumber
         name
         driverName
         driverAddress
         originAddress
         destinationAddress
         forestProducts {
            kind
            species
            scientificName
            numberOfTrees
            quantity {
               value
               unit
            }
            volume {
               cubicMeters
               boardFeet
            }
         }
         conveyance
         vehiclePlateNumber
         consignee
         permitNumber
      }
   }
`;

export const CSAW_CERTIFICATE_FIELDS = gql`
   fragment CSAWCertificateFields on Certificate {
      csawCertificateData {
         registrationType
         ownerName
         address
         purpose
         chainsawDetails {
            brand
            model
            serialNumber
            dateOfAcquisition
            powerOutput
            maxLengthGuidebar
            countryOfOrigin
            purchasePrice
         }
         otherDetails
      }
   }
`;